package ext

import three.js.Object3D

/**
 * Clone the given object, including materials.
 */
fun Object3D.deepClone(): Object3D {
    val cloned = clone(true)

    // recursively clone all children's materials
    children.toList().forEach {
        it.asDynamic().material = it.asDynamic().material?.clone()
    }

    return cloned
}

/**
 * Change the color of each child's material.
 */
@Suppress("UnsafeCastFromDynamic")
fun Object3D.changeMaterialColor(color: Int) {
    children.forEach {
        it.asDynamic().material?.color?.setHex(color)
    }
}

/**
 * Change the transparency of each child's material.
 */
fun Object3D.changeMaterialTransparency(transparency: Double) {
    children.forEach {
        it.asDynamic().material?.transparent = true
        it.asDynamic().material?.opacity = transparency
    }
}